export const common = {
  conferences: {
    url: process.env.NEXT_PUBLIC_CONFERENCES || '',
  },
};
